<template>

  <div class="py-4 container-fluid">
    <!-- Fila 1: Crear empleado -->
    <div class="row align-items-stretch g-1 mb-3 justify-content-start">
      <div class="col-12 col-lg-8 col-xl-7">
        <div class="card w-100">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0 section-title page-title">CREAR EMPLEADO</p>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <label for="example-text-input" class="form-control-label">Nombre</label>
                <argon-input type="text" v-model="user.name" />
              </div>
              <div class="col-md-6">
                <label for="document-type" class="form-control-label">Tipo de Documento</label>
                <select id="documentType" class="form-control" v-model="user.document_type">
                  <option value="" disabled>Seleccione un tipo de documento</option>
                  <option value="CC">Cédula de Ciudadanía (CC)</option>
                  <option value="CE">Cédula de Extranjería (CE)</option>
                  <option value="TI">Tarjeta de Identidad (TI)</option>
                  <option value="RC">Registro Civil (RC)</option>
                  <option value="PA">Pasaporte (PA)</option>
                  <option value="PEP">Permiso Especial de Permanencia (PEP)</option>
                  <option value="NIT">Número de Identificación Tributaria (NIT)</option>
                </select>
              </div>
              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Número documento</label>
                <argon-input type="text" v-model="user.document" autocomplete="off" />
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Dirección</label>
                <argon-input type="text" v-model="user.address" autocomplete="off" />
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Teléfono</label>
                <argon-input type="text" v-model="user.phone" autocomplete="off" />
              </div>
              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Correo electrónico</label>
                <argon-input type="email" v-model="user.email" autocomplete="off" />
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Contraseña</label>
                <argon-input type="password" v-model="user.password" autocomplete="off" />
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Confirmar Contraseña</label>
                <argon-input type="password" v-model="user.password_confirmation" autocomplete="off" />
              </div>


              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Forma de pago</label>
                <select name="" id="role" class="form-select" v-model="user.payment">
                  <option value="0">Mensualidad</option>
                  <option value="1">Por Tarea</option>
                </select>
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Cargo</label>
                <select name="" id="role" class="form-select" v-model="user.role">
                  <option value="1">Administrador</option>
                  <option value="2">Supervisor</option>
                  <option value="3">Operario</option>
                </select>
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Área</label>
                <select name="" id="area" class="form-select" v-model="user.area_id">
                  <option value="" disabled>Seleccione un área</option>
                  <option v-for="bodega in bodegas" :key="bodega.id" :value="bodega.id">
                    {{ bodega.name }}
                  </option>
                </select>
              </div>

              <div class="col-6 mb-3">
                <label for="example-text-input" class="form-control-label">Cuadrilla</label>

                <select ref="cuadrillaSelect" id="cuadrilla" class="form-select select2" style="width:100%;">
                  <option  value="">
                    Seleccionar cuadrilla
                  </option>
                  <option v-for="process in cuadrillas" :key="process.id" :value="process.id">
                    {{ process.name }}
                  </option>
                </select>
              </div>


              <div class="col-md-12">
                <label for="processes-checkbox-list" class="form-control-label">Procesos</label>
                <div id="processes-checkbox-list" class="checkbox-grid">
                  <div v-for="process in processes" :key="process.id">
                    <argon-checkbox :id="'process-' + process.id" :value="process.id"
                      :checked="user.processes.includes(process.id)" v-model="user.processes">
                      {{ process.name }}
                    </argon-checkbox>
                  </div>

                </div>
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Estado</label>
                <select name="" id="status" class="form-select" v-model="user.status">
                  <option value="1">Activo</option>
                  <option value="0">Inactivo</option>
                </select>
              </div>
              <div class="col-md-6 d-flex align-items-end justify-content-end">
                <argon-button color="warning" size="sm" @click="save">Guardar</argon-button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Fila 2: Historial de cambios de cuadrilla (debajo de crear empleado, solo al editar) -->
    <div class="row align-items-stretch g-1 justify-content-start" v-if="user.id !== 0">
      <div class="col-12 col-lg-8 col-xl-7">
        <div class="card w-100">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center justify-content-between">
              <h6 class="mb-0 section-title">HISTORIAL DE CAMBIOS DE CUADRILLA</h6>
            </div>
          </div>
          <div class="card-body pt-0 pb-2 overflow-auto history-card-body history-card-body-px">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0 history-table">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      C.Anterior
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      C.Actual
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Fecha de Cambio
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="cuadrillaHistory.length === 0">
                    <td colspan="3" class="text-center">
                      <p class="text-xs text-secondary mb-0">No hay cambios de cuadrilla registrados</p>
                    </td>
                  </tr>
                  <tr v-for="(item, index) in cuadrillaHistory" :key="index">
                    <td>
                      <span class="history-cell">
                        {{ item.cuadrilla_anterior || item.cuadrillaAnterior ? (item.cuadrilla_anterior || item.cuadrillaAnterior).name : 'Sin cuadrilla' }}
                      </span>
                    </td>
                    <td>
                      <span class="history-cell">
                        {{ item.cuadrilla_actual || item.cuadrillaActual ? (item.cuadrilla_actual || item.cuadrillaActual).name : 'Sin cuadrilla' }}
                      </span>
                    </td>
                    <td class="align-middle text-sm">
                      <span class="history-cell">
                        {{ formatDate(item.fecha) }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<style scoped>
.page-title {
  font-size: 1.15rem;
}

.section-title {
  font-weight: 800;
  color: #1f2d5a;
  letter-spacing: 0.6px;
  font-size: 0.95rem;
}

.section-title::after {
  content: "";
  display: block;
  width: 44px;
  height: 3px;
  margin-top: 6px;
  border-radius: 999px;
  background: #f6a500;
}

.history-card-body {
  /* Keep equal-height cards, but avoid ultra-tall scroll areas on very large screens */
  max-height: 520px;
}

/* Alinear contenido de la tabla con el título del card (mismo padding que card-header: 1.5rem) */
.history-card-body-px {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.history-card-body::-webkit-scrollbar {
  width: 8px;
}
.history-card-body::-webkit-scrollbar-thumb {
  background: rgba(31, 45, 90, 0.25);
  border-radius: 999px;
}

.history-table {
  table-layout: auto;
  width: 100%;
}

.history-table thead th {
  color: #1f2d5a !important;
  opacity: 1 !important;
  font-weight: 800 !important;
  letter-spacing: 0.6px;
  font-size: 0.72rem !important;
}

.history-table tbody td {
  font-size: 0.85rem;
  color: #344767;
}

.history-cell {
  font-size: 0.85rem;
  font-weight: 600;
  color: #344767;
  line-height: 1.2;
}

/* Mismo padding en th y td para que título y dato de cada columna empiecen igual */
.history-table thead th,
.history-table tbody td {
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
  vertical-align: middle !important;
}

.history-table thead th,
.history-table tbody td {
  text-align: left !important;
}

.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  /* Dos columnas iguales */
}
</style>

<script>
import setNavPills from "../../../assets/js/nav-pills.js";
import setTooltip from "../../../assets/js/tooltip.js";
import ArgonInput from "../../../components/ArgonInput.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import ArgonCheckbox from "../../../components/ArgonCheckbox.vue";
import { useRoute } from "vue-router";
import Swal from 'sweetalert2';
import $ from 'jquery';

const body = document.getElementsByTagName("body")[0];


export default {
  name: "User Create",
  data() {
    return {
      showMenu: false,
      user: {
        id: 0,
        name: '',
        document_type: '',
        document: '',
        address: '',
        email: '',
        password: '',
        password_confirmation: '',
        role: '1',
        area_id: '',
        status: '1',
        phone: '',
        payment: '',
        processes: [],
        cuadrilla:'',
      },
      bodegas: [],
      processes: [],
      cuadrillas: [],
      filteredCuadrillas: [],
      cuadrillaHistory: [],
    };
  },
  components: { ArgonInput, ArgonButton, ArgonCheckbox },
  methods: {

    async save() {
      try {
        // Asegurar que el valor de cuadrilla se capture del select2 antes de guardar
        if (this.$refs.cuadrillaSelect) {
          const valorSelect = $(this.$refs.cuadrillaSelect).val();
          this.user.cuadrilla = valorSelect === '' || valorSelect === null ? null : valorSelect;
        }
        
        // Log temporal para depuración
        console.log('Guardando usuario - Datos a enviar:', {
          id: this.user.id,
          cuadrilla: this.user.cuadrilla,
          cuadrilla_tipo: typeof this.user.cuadrilla,
          user_completo: this.user
        });
        
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("users/save", this.user);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El empleado ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el empleado');
        }
        
        // Recargar el historial después de guardar si se está editando
        if (this.user.id && this.user.id !== 0) {
          await this.getCuadrillaHistory();
        }
      } catch (error) {
        console.error("Error al crear el empleado:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el empleado',
        });
      }
    },
    async getBodegas() {
      this.bodegas = await this.$store.dispatch('bodegas/getAll');
    },
    async getOficios() {
      this.processes = await this.$store.dispatch('users/getOficios');
    },
    async getCuadrillas() {
      this.cuadrillas = await this.$store.dispatch('crews/getAll');

      $(this.$refs.cuadrillaSelect).select2({
        placeholder: 'Seleccione una cuadrilla',
        allowClear: false,
      }).on('change', () => {
        const valor = $(this.$refs.cuadrillaSelect).val();
        this.user.cuadrilla = valor === '' || valor === null ? null : valor;
        console.log('Select2 cuadrilla cambiado:', { valor, user_cuadrilla: this.user.cuadrilla });
      });
    },
    selectCuadrilla(cuadrilla) {
      this.user.cuadrilla = cuadrilla;
      this.filteredCuadrillas = [];
    },
    async getCuadrillaHistory() {
      if (this.user.id && this.user.id !== 0) {
        try {
          this.cuadrillaHistory = await this.$store.dispatch('users/getCuadrillaHistory', this.user.id);
        } catch (error) {
          console.error("Error al obtener el historial de cuadrilla:", error);
          this.cuadrillaHistory = [];
        }
      }
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const s = String(dateString);
      // Prefer string-based formatting to avoid timezone conversions in the browser
      const m = s.match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/);
      if (m) {
        const yy = m[1].slice(-2);
        return `${m[3]}/${m[2]}/${yy}, ${m[4]}:${m[5]}`;
      }

      // Fallback: try Date parsing (best effort)
      const normalized = s.replace(' ', 'T');
      const d = new Date(normalized);
      if (Number.isNaN(d.getTime())) return s;
      const pad2 = (n) => String(n).padStart(2, '0');
      const dd = pad2(d.getDate());
      const mm = pad2(d.getMonth() + 1);
      const yy = String(d.getFullYear()).slice(-2);
      const hh = pad2(d.getHours());
      const min = pad2(d.getMinutes());
      return `${dd}/${mm}/${yy}, ${hh}:${min}`;
    }
  },
  mounted() {

    this.getOficios();
    this.getBodegas();
    this.getCuadrillas();


    const route = useRoute();
    const data = route.params.user;

    this.$nextTick(() => {
      $(this.$refs.processesSelect).select2();

      $(this.$refs.processesSelect).on('change', (event) => {
        this.user.processes = JSON.stringify($(event.target).val());
      });
    });

    if (data) {
      try {
        const params = JSON.parse(data); // Asegúrate de que este JSON se pueda parsear

        // Verifica si params contiene los datos de user
        if (params && params.id) {
          // Llena los campos del formulario con los datos del empleado
          this.user = params;
          this.user.id = params.id || 0;
          this.user.name = params.name || '';
          this.user.document_type = params.document_type || '';
          this.user.document = params.document || '';
          this.user.address = params.address || '';
          this.user.email = params.email || '';
          this.user.role = params.role || '1';
          this.user.status = params.status || '1';
          this.user.phone = params.phone || '';
          this.user.payment = params.payment || 0;
          this.user.processes = JSON.parse(params.processes) || [];
          $(this.$refs.processesSelect).val(this.user.processes).trigger('change');
          this.user.cuadrilla = params.cuadrilla || '';

          console.log('this.user.cuadrilla',this.user.cuadrilla);
          setTimeout(() => {
              $(this.$refs.cuadrillaSelect).val(this.user.cuadrilla).trigger('change');
          }, 2000); 

          // Cargar el historial de cuadrilla cuando se está editando un usuario
          this.getCuadrillaHistory();
        }
      } catch (error) {
        console.error("Error al parsear los datos del empleado:", error);
      }
    }

    this.$store.state.isAbsolute = false;
    setNavPills();
    setTooltip();
  },
  beforeMount() {
    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>
